export default "__VITE_ASSET__DIiiB00j__"